export const CREATE_BUNDLE_GROUP_ID = 'createRegulatoryBundle';
export const CREATE_BUNDLE_COUNTRY_FIELD_ID = 'country';
export const CREATE_BUNDLE_PHONE_TYPE_FIELD_ID = 'phoneType';
export const SELECTED_ACCEPTED_DOC_KEY_PATH = [
  'manageMyOrg',
  'internationalProvisioning',
  'selectedAcceptedDocument',
];
export const UPLOAD_DOCUMENT_INPUTS_KEY_PATH = [
  'manageMyOrg',
  'internationalProvisioning',
  'input',
];
export const ADDRESS_FORM_GROUP_ID = 'internationalProvisioningAddress';
export const CREATE_BUNDLE_ERROR_DIALOG_KEYPATH = [
  'manageMyOrg',
  'internationalProvisioning',
  'createBundleErrorOpen',
];
export const CONFIRM_ASSIGN_DIALOG_UI_KEYPATH = [
  'manageMyOrg',
  'internationalProvisioning',
  'confirmAssignDialogOpen',
];
export const ASSIGN_NUMBER_USER_DETAILS = [
  'manageMyOrg',
  'internationalProvisioning',
  'confirmAssignUserDetails',
];

export const TWILIO_INPUT_DATA_TYPES = {
  String: 'text',
  Date: 'date',
  List: 'address',
};

export const LOCAL_DIAL_TABLE_ID = 'localDial';

// our npm package includes alpha2 country codes that are not supported
// so we list them here for purposes of filtering it out for context see
// https://groovelabs.atlassian.net/browse/DIAL-421
export const UNSUPPORTED_ALPHA2_CODES = [
  'AC',
  'AN',
  'BU',
  'CP',
  'CS',
  'CS',
  'CT',
  'DD',
  'DG',
  'DY',
  'EA',
  'EU',
  'FQ',
  'FX',
  'HV',
  'IC',
  'JT',
  'MI',
  'NH',
  'NQ',
  'NT',
  'PC',
  'PU',
  'PZ',
  'RH',
  'SU',
  'TA',
  'TP',
  'UK',
  'VD',
  'WK',
  'XK',
  'YD',
  'YU',
  'ZR',
];

export const RESULT_MAP = {
  PENDING: 'Pending',
  IN_PROGRESS: 'In Progress',
  SUCCESS: 'Done',
  FAILURE: 'Failure',
};

export const PENDING = 'PENDING';
export const IN_PROGRESS = 'IN_PROGRESS';
export const FAILURE = 'FAILURE';
export const SUCCESS = 'SUCCESS';

export const PROVISIONING_ERROR_CODE_MAP = {
  21651:
    'Missing address for the regulatory bundle. Please contact support for further guidence.',
  20400:
    'The number type you selected doesn’t meet the country requirements for local numbers. Please ensure to start appropriate bundle type for this country that will support selected number type. Or contact support for further assitance.',
  21649:
    'Regulatory bundle required. To purchase this number, please submit a regulatory bundle for this country and number type.',
  default:
    'Twilio error: {{message_placeholder_to_replace}} \n Clari support team is here to help! Please don’t hesitate to reach out.',
};

export const PROVISIONING_ERROR_MESSAGE_MAP = {
  'Address Missing':
    'An address is missing. Please contact support so we can help you add the correct details.',
  'Bundle Missing':
    'Regulatory bundle required. To purchase this number, please submit a regulatory bundle for this country and number type.',
  'Unable to find suitable Messaging Service for phone number assignment':
    'We couldn’t find a matching messaging service for this number. Please contact support for further assistance.',
  default:
    "We're sorry, something went wrong while trying to purchase the phone number. No worries, our support team is here to help! Please don’t hesitate to reach out.",
};
